var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"team-members"},[_c('v-row',[_vm._l((_vm.members),function(member,i){return [_c('v-col',{key:i,attrs:{"cols":"12"}},[_c('team-member',_vm._b({},'team-member',{ member },false))],1),(i < _vm.members.length - 1)?_c('v-divider',{key:`divider-${i}`,staticClass:"mb-1 flex-1-1-100"}):_vm._e()]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }